// extracted by extract-css-chunks-webpack-plugin
module.exports = {"agreements-wrapper":"award-unit-account__agreements-wrapper--1MsIL","agreementsWrapper":"award-unit-account__agreements-wrapper--1MsIL"};